<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-header py-3">
                <h3 class="m-0 font-weight-bold text-primary mb-2">
                    Membership Orders
                </h3>
            </div>
            <div v-if="deleteResponse.success != null" v-bind:class="{ 'alert-success': deleteResponse.success, 'alert-danger': !deleteResponse.success }" class="alert" role="alert">
                {{deleteResponse.message}}
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <b-table show-empty
                             striped
                             :items="orders"
                             :fields="fields">
                        <template v-slot:cell(hash)="row">
                            {{row.value}}
                        </template>
                        <template v-slot:cell(processed)="row">
                            <input type="checkbox" disabled :checked="row.value" />
                        </template>
                        <template v-slot:cell(start)="row">
                            {{ row.value.replace('T', ' ').slice(0,19) }}
                        </template>
                        <template v-slot:cell(end)="row">
                            {{ row.value.replace('T', ' ').slice(0,19) }}
                        </template>
                        <template v-slot:cell(paymentDate)="row">
                            {{ row.value.replace('T', ' ').slice(0,19) }}
                        </template>
                        <template v-slot:cell(doctor)="row">
                            <router-link :to="'/admin/doctors/info/' + row.item.doctor.doctorId" class="btn btn-primary">Doctor</router-link>
                        </template>
                        <template v-slot:cell(activate)="row">
                            <button v-if="!row.item.isTrial && !row.item.processed" @click="showActivationPopup(row.item.id)" class="btn btn-success">Activate</button>
                            <a v-else class="btn btn-disabled disabled">Activated</a>
                        </template>
                    </b-table>
                </div>
                <b-pagination-nav 
                    v-model="currentPage" 
                    :link-gen="linkGeneration" 
                    :number-of-pages="totalPages" 
                    use-router 
                    align="center"
                    :first-text="this.$t('PAGING_FIRST_PAGE')"
                    :last-text="this.$t('PAGING_LAST_PAGE')" >
                </b-pagination-nav>
            </div>
        </div>
        <modal :title="$t('ACTIVATE_MEMBERSHIP')" v-if="showActivationModal" @close="showActivationModal = false">
            <template v-slot:body>
                <div class="form-group">
                    <label>Select Membership Payment Date</label>
                    <datetime type="date"
                              v-model="paymentDate"
                              min-datetime="1900-01-01T00:00:00.000Z"
                              input-class="form-control"
                              placeholder="Payment Date"></datetime>
                </div>
            </template>
            <template v-slot:footer>
                <button @click="activateMembership" class="btn btn-success">Activate</button>
            </template>
        </modal>
    </div>
</template>

<script>
import Modal from './../../misc/Modal.vue';
import pagingMixin from './../../../mixins/pagingMixin'
    
export default {
    mixins: [ pagingMixin ],
    components: {
        modal: Modal
    },
    data() {
        return {
            orders: [],
            currentPage: null,
            totalOrders: 0,
            totalPages: 1,
            fields: [
                { key: 'hash', label: 'Order Number' },
                { key: 'start', label: 'Start Date', sortable: true },
                { key: 'end', label: 'End Date', sortable: true },
                { key: 'paymentDate', label: 'Payment Date', sortable: true },
                { key: 'processed', label: 'Processed' },
                { key: 'doctor', label: 'Doctor', tdClass: 'fit' },
                { key: 'activate', label: 'Activate', tdClass: 'fit' },
            ],
            deleteResponse: {},
            modalBody: "Select 'Delete' below if you are sure you want to delete the selected membership order",
            modalTitle: "Delete Confirmation",
            modalButtonText: "Delete",
            showModal: false,
            modalOrderId: null,
            showActivationModal: false,
            paymentDate: null,
            selectedMembership: null
        }
    },
    methods: {
        enableDeleteModal: function (order) {
            this.modalOrderId = order.id;
            this.showModal = true;
        },
        deleteOrder: function (doctorId) {

        },
        loadOrders: function () {
            this.$http.get('/api/membership/orders/all?p=' + this.currentPage)
                .then(response => {
                    this.orders = response.data;
                }).catch(error => {
                    console.log(error);
                })
        },
        loadTotalOrdersCount: function () {
            this.$http
                .get('/api/membership/orders/all/count')
                .then(response => {
                    this.totalOrders = response.data;
                    this.totalPages = this.calculateNumberOfPages(this.totalOrders);
                }).catch(error => {
                    console.log(error);
                })
        },
        linkGeneration: function (pageNumber) {
            return {
                path: '/admin/membership-orders',
                query: { p: pageNumber }
            }
        },
        showActivationPopup: function (membershipId) {
            this.showActivationModal = true;
            this.selectedMembership = membershipId;
        },
        activateMembership: function () {
            this.$http
                .post('/api/membership/activate', {
                    membershipId: this.selectedMembership,
                    paymentDate: this.paymentDate
                }).then(response => {
                    this.showActivationModal = false;
                    this.paymentDate = null;
                    this.selectedMembership = null;
                    this.loadOrders();
                    this.loadTotalOrdersCount();
                }).catch(error => {

                });
        },
    },
    created: function () {
        this.currentPage = this.$route.query.p ? Number(this.$route.query.p) : 1;
    },
    watch: {
        deleteResponse: function (val) {
            setTimeout(() => { this.deleteResponse.success = null }, 3000)
        },
        currentPage: function () {
            this.loadOrders();
            this.loadTotalOrdersCount();
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "~vue-datetime/dist/vue-datetime.min.css";
</style>